export default "__VITE_ASSET__CoZZzzw3__"